import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class alfreditoService {
  private urlBase = environment.options.taskUrl;
  private inspector_id = environment.options.inspector_id

  categoriesRoomService = ['Fuertes', 'Comidas Rápidas', 'Postres', 'Bebidas']

  constructor(private http: HttpClient) {

  }

  crearTipoTarea(body) {
    let params = this.ObjecttoParams(body);
    const headers: HttpHeaders = this.getHeaders();
    return this.http.post(`${this.urlBase}funcionario/newTipoTarea`, params, { headers })
  }

  crearTareas(body) {
    let params = this.ObjecttoParams(body);
    const headers: HttpHeaders = this.getHeaders();
    return this.http.post(`${this.urlBase}funcionario/newtareaSmallshi`, params, { headers })

  }

  getListadoTareas() {
    const headers: HttpHeaders = this.getHeaders();
    return this.http.get(`${this.urlBase}funcionario/listareas?inspector_id=${this.inspector_id}`, { headers })
  }

  getHeaders() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Basic YWRtaW46M3lHQTU0ZkI='
    })

    return headers;
  }

  ObjecttoParams(obj) {
    var p = [];
    for (var key in obj) {
      p.push(key + '=' + encodeURIComponent(obj[key]));
    }
    return p.join('&');
  }

  reviewCategory(category: string) {
    let isRoomService = this.categoriesRoomService.some(categoryRoomService => category == categoryRoomService)
    return (isRoomService) ? '2' : '1';
  }
}
